export default "/images/f011377b3be11e6d2c84b903cafe2a2c.avif";